import React from "react";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Table } from "../../../../../../Shared/Table/Table";
import { Organisation } from "../../../../../../../Wrap/Models/Models/Customer/Organisation";
import { ShareOfTrustItem } from "../../../../../../../Wrap/Models/Models/Customer/ShareOfTrustItem";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { AdditionalDataItemType } from "../../../../../../../Wrap/Constants/Enums/Domain/AdditionalDataItemType";
import { AddTrustMemberAction } from "../../AddTrustMember/Action/AddTrustMemberAction";
import { OrganisationMemberPopUpInfo } from "../../../AddClient/Resource/Contents";
import { AccountRoleActorCategory } from "../../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";

interface IShareOfTrustTableProps extends IProcessComponentProps {
    organisation: Organisation;
    deletedBeneficiary: OrganisationMember;
    remainingBeneficiaries: Array<OrganisationMember>;
    isAddBeneficiary: boolean;
    IsAddAdditionalBeneficiary: boolean;
    accountId: number;
}

interface IShareOfTrustTableState {
    applyEqualShare: boolean;
    currentShares: Array<ShareOfTrustItem>;
}

export class ShareOfTrustTable extends ProcessComponent<IShareOfTrustTableProps, IShareOfTrustTableState> {
    constructor(props: IShareOfTrustTableProps) {
        super(props);
        this.state = {
            applyEqualShare: false,
            currentShares: [],
        };
    }

    isValid() {
        const flag = super.isValid();
        const { organisation, isAddBeneficiary, IsAddAdditionalBeneficiary } = this.props;
        let sum = 0;
        let newBeneficiaries;
        if (isAddBeneficiary) {
            if (IsAddAdditionalBeneficiary) {
                newBeneficiaries = organisation?.Beneficiaries?.filter((x) =>
                    x.Relationships.includes(RelationshipType.Beneficiary)
                );
            } else {
                newBeneficiaries = organisation?.OrganisationMembers?.filter((x) =>
                    x.Relationships.includes(RelationshipType.Beneficiary)
                );
            }
        }
        newBeneficiaries.forEach((x) => {
            const share = x?.Percentage ? Number(x?.Percentage) : 0;
            sum = sum + share;
        });
        if (!CommonHelper.isNullOrEmpty(organisation?.ShareOfTrustItem)) {
            organisation?.ShareOfTrustItem.forEach((x) => {
                const share = x?.Percentage ? Number(x?.Percentage) : 0;
                sum = sum + share;
            });
        }
        if (Math.abs(100 - sum) > 0.1) {
            this.props.showErrorMsgPopUp([OrganisationMemberPopUpInfo.shareOfTrustWarning], true);
            return false;
        }
        return flag;
    }

    componentDidMount() {
        super.componentDidMount();
        const {
            deletedBeneficiary,
            remainingBeneficiaries,
            isAddBeneficiary,
            accountId,
            organisation,
            onChange,
        } = this.props;
        const beneficiaries = remainingBeneficiaries;

        AddTrustMemberAction.getShareOfTrust(organisation?.CustomerId, (result) => {
            this.setState({ currentShares: result });
        });
        const shareOfTrusts: Array<ShareOfTrustItem> = [];

        beneficiaries.forEach((beneficiary) => {
            shareOfTrusts.push({
                CustomerId: beneficiary?.CustomerId,
                AccountId: accountId,
                AccountRoleType:
                    beneficiary?.Individual?.ActorCategory == AccountRoleActorCategory.Customer
                        ? RoleType.Beneficiary
                        : RoleType.AdditionalBeneficiary,
                AdditionalDataItemType: AdditionalDataItemType.ShareOfTrust,
                Percentage: 0,
            });
        });

        if (isAddBeneficiary == false) {
            if (deletedBeneficiary?.Individual?.ActorOwnerId != 0) {
                this.onShareOfTrustChange([
                    { value: shareOfTrusts, path: `ShareOfTrustItem` },
                    {
                        value: {
                            CustomerId: deletedBeneficiary?.CustomerId,
                            AccountId: accountId,
                            AccountRoleType:
                                deletedBeneficiary?.Individual?.ActorCategory == AccountRoleActorCategory.Customer
                                    ? RoleType.Beneficiary
                                    : RoleType.AdditionalBeneficiary,
                            AdditionalDataItemType: AdditionalDataItemType.ShareOfTrust,
                            Percentage: 0,
                        },
                        path: `ShareOfTrustToDelete`,
                    },
                ]);
            } else {
                this.onShareOfTrustChange([{ value: shareOfTrusts, path: `ShareOfTrustItem` }]);
            }
        } else {
            this.onShareOfTrustChange([{ value: shareOfTrusts, path: `ShareOfTrustItem` }]);
        }
    }

    private applyEqualShare() {
        const {
            organisation,
            deletedBeneficiary,
            remainingBeneficiaries,
            isAddBeneficiary,
            IsAddAdditionalBeneficiary,
        } = this.props;
        let beneficiaries = remainingBeneficiaries;
        let newBeneficiaryCount = 0;
        this.setState({ applyEqualShare: true });
        if (isAddBeneficiary) {
            if (IsAddAdditionalBeneficiary) {
                beneficiaries = beneficiaries.concat(organisation?.Beneficiaries);
                newBeneficiaryCount = (organisation?.Beneficiaries || []).length;
            } else {
                const newBeneficiaries = organisation?.OrganisationMembers.filter((x) =>
                    x.Relationships.includes(RelationshipType.Beneficiary)
                );
                beneficiaries = beneficiaries.concat(newBeneficiaries);
                newBeneficiaryCount = (newBeneficiaries || []).length;
            }
        } else {
            if (deletedBeneficiary != null) {
                beneficiaries = beneficiaries.filter((x) => x.CustomerId != deletedBeneficiary?.CustomerId);
            }
        }
        const percentage = CommonHelper.downFixed(100 / beneficiaries.length, 2);
        const change = [];
        for (let i = 0; i < beneficiaries.length; i++) {
            if (i < beneficiaries.length - newBeneficiaryCount) {
                change.push({
                    value: percentage.toString(),
                    path: `ShareOfTrustItem.${i}.Percentage`,
                });
            } else {
                if (IsAddAdditionalBeneficiary) {
                    change.push({
                        value: percentage.toString(),
                        path: `Beneficiaries.${i - beneficiaries.length + newBeneficiaryCount}.Percentage`,
                    });
                } else {
                    change.push({
                        value: percentage.toString(),
                        path: `OrganisationMembers.${i - beneficiaries.length + newBeneficiaryCount}.Percentage`,
                    });
                }
            }
        }
        this.onShareOfTrustChange(change);
    }

    private onShareOfTrustChange = (changes: { value: any; path: string }[]) => {
        const { organisation } = this.props;
        let _model = { ...organisation };
        changes.forEach((change) => {
            _model = setValueByKey(_model, change.path, change.value);
        });
        this.props.onChange(_model);
    };

    private renderBeneficiariesTable() {
        const {
            organisation,
            deletedBeneficiary,
            remainingBeneficiaries,
            isAddBeneficiary,
            IsAddAdditionalBeneficiary,
        } = this.props;
        const { applyEqualShare, currentShares } = this.state;
        let beneficiaries = JSON.parse(JSON.stringify(remainingBeneficiaries));
        let newBeneficiaryCount = 0;
        if (isAddBeneficiary == true) {
            if (IsAddAdditionalBeneficiary) {
                beneficiaries = beneficiaries.concat(organisation?.Beneficiaries);
                newBeneficiaryCount = (organisation?.Beneficiaries || []).length;
            } else {
                const newBeneficiaries = organisation?.OrganisationMembers.filter((x) =>
                    x.Relationships.includes(RelationshipType.Beneficiary)
                );
                beneficiaries = beneficiaries.concat(newBeneficiaries);
                newBeneficiaryCount = (newBeneficiaries || []).length;
            }
        } else {
            if (deletedBeneficiary != null) {
                if (deletedBeneficiary?.Individual?.ActorOwnerId != 0) {
                    beneficiaries.push(deletedBeneficiary);
                }
            }
        }
        const lastBeneficiaryIndex =
            deletedBeneficiary?.Individual?.ActorOwnerId != 0 ? beneficiaries.length - 1 : beneficiaries.length;
        return (
            <>
                <h3>Share of trust</h3>
                <Table
                    data={beneficiaries}
                    col={[
                        {
                            title: "Title",
                            key: "Individual.PersonalDetails.Title",
                            render: (v) => {
                                return TitleMap.getString(v);
                            },
                        },
                        { title: "First name", key: "Individual.PersonalDetails.GivenName" },
                        { title: "Surname", key: "Individual.PersonalDetails.FamilyName" },
                        {
                            title: "Date of birth",
                            key: "Individual.PersonalDetails.DateOfBirth",
                            render: (v) => JsonDateParser.getFormatDate(v, "dd/MM/yyyy"),
                        },
                        {
                            title: "Current share of trust %",
                            key: "CustomerId",
                            render: (v) => {
                                const currentShare = currentShares.filter((x) => x.CustomerId == v);
                                if (!CommonHelper.isNullOrEmpty(currentShare)) {
                                    return currentShare[0].Percentage.toString();
                                }
                                return "0";
                            },
                        },
                        {
                            title: "New share of trust %",
                            key: "",
                            render: (data, row: OrganisationMember, index) => {
                                if (
                                    (isAddBeneficiary && index <= lastBeneficiaryIndex - newBeneficiaryCount) ||
                                    (isAddBeneficiary == false && index != lastBeneficiaryIndex)
                                ) {
                                    return (
                                        <>
                                            <NumberTextBoxEditor
                                                cssWrapper={"minWidth85"}
                                                atMost={{
                                                    errorMessage: `please enter a value between 0 and 100`,
                                                    value: 100,
                                                }}
                                                atLeast={{
                                                    errorMessage: `please enter a value larger than 0`,
                                                    value: 0,
                                                }}
                                                disabled={
                                                    (index == lastBeneficiaryIndex && !isAddBeneficiary) ||
                                                    applyEqualShare
                                                }
                                                value={
                                                    organisation?.ShareOfTrustItem[index]?.Percentage
                                                        ? Number(organisation?.ShareOfTrustItem[index]?.Percentage)
                                                        : 0
                                                }
                                                onChange={(v) => {
                                                    this.onShareOfTrustChange([
                                                        {
                                                            value: v?.toString(),
                                                            path: `ShareOfTrustItem.${index}.Percentage`,
                                                        },
                                                    ]);
                                                }}
                                                maxNumberOfDecimalPlaces={{
                                                    errorMessage: "only allow two decimal places",
                                                    value: 2,
                                                }}
                                            />
                                        </>
                                    );
                                } else if (isAddBeneficiary && index > lastBeneficiaryIndex - newBeneficiaryCount) {
                                    return (
                                        <>
                                            <NumberTextBoxEditor
                                                atMost={{
                                                    errorMessage: `please enter a value between 0 and 100`,
                                                    value: 100,
                                                }}
                                                atLeast={{
                                                    errorMessage: `please enter a value larger than 0`,
                                                    value: 0,
                                                }}
                                                disabled={
                                                    (index == lastBeneficiaryIndex && !isAddBeneficiary) ||
                                                    applyEqualShare
                                                }
                                                value={
                                                    IsAddAdditionalBeneficiary
                                                        ? organisation?.Beneficiaries[
                                                              index - lastBeneficiaryIndex + newBeneficiaryCount - 1
                                                          ]?.Percentage
                                                            ? Number(
                                                                  organisation?.Beneficiaries[
                                                                      index -
                                                                          lastBeneficiaryIndex +
                                                                          newBeneficiaryCount -
                                                                          1
                                                                  ]?.Percentage
                                                              )
                                                            : 0
                                                        : organisation?.OrganisationMembers[
                                                              index - lastBeneficiaryIndex + newBeneficiaryCount - 1
                                                          ]?.Percentage
                                                        ? Number(
                                                              organisation?.OrganisationMembers[
                                                                  index - lastBeneficiaryIndex + newBeneficiaryCount - 1
                                                              ]?.Percentage
                                                          )
                                                        : 0
                                                }
                                                onChange={(v) => {
                                                    if (IsAddAdditionalBeneficiary) {
                                                        this.onShareOfTrustChange([
                                                            {
                                                                value: v?.toString(),
                                                                path: `Beneficiaries.${
                                                                    index -
                                                                    lastBeneficiaryIndex +
                                                                    newBeneficiaryCount -
                                                                    1
                                                                }.Percentage`,
                                                            },
                                                        ]);
                                                    } else {
                                                        this.onShareOfTrustChange([
                                                            {
                                                                value: v?.toString(),
                                                                path: `OrganisationMembers.${
                                                                    index -
                                                                    lastBeneficiaryIndex +
                                                                    newBeneficiaryCount -
                                                                    1
                                                                }.Percentage`,
                                                            },
                                                        ]);
                                                    }
                                                }}
                                                maxNumberOfDecimalPlaces={{
                                                    errorMessage: "only allow two decimal places",
                                                    value: 2,
                                                }}
                                            />
                                        </>
                                    );
                                } else if (!isAddBeneficiary && index == lastBeneficiaryIndex) {
                                    return (
                                        <>
                                            <NumberTextBoxEditor
                                                atMost={{
                                                    errorMessage: `please enter a value between 0 and 100`,
                                                    value: 100,
                                                }}
                                                atLeast={{
                                                    errorMessage: `please enter a value larger than 0`,
                                                    value: 0,
                                                }}
                                                disabled={
                                                    (index == lastBeneficiaryIndex && !isAddBeneficiary) ||
                                                    applyEqualShare
                                                }
                                                value={
                                                    organisation?.ShareOfTrustToDelete?.Percentage
                                                        ? Number(organisation?.ShareOfTrustToDelete?.Percentage)
                                                        : 0
                                                }
                                                onChange={(v) => {
                                                    this.onShareOfTrustChange([
                                                        {
                                                            value: v?.toString(),
                                                            path: `ShareOfTrustToDelete.Percentage`,
                                                        },
                                                    ]);
                                                }}
                                                maxNumberOfDecimalPlaces={{
                                                    errorMessage: "only allow two decimal places",
                                                    value: 2,
                                                }}
                                            />
                                        </>
                                    );
                                }
                            },
                        },
                    ]}
                />
                <CheckboxEditor
                    label="Equal share"
                    cssWrapper="square-checkbox block mt-19"
                    onChange={(v) => {
                        if (v) {
                            this.applyEqualShare();
                        } else {
                            this.setState({ applyEqualShare: false });
                        }
                    }}
                />
            </>
        );
    }

    render() {
        return <>{this.renderBeneficiariesTable()}</>;
    }
}
